import React, { useEffect, useState } from "react";
import { getTexts } from "../utils/i18n";

const UserAgreementPopup: React.FC = () => {
    const [isAgreementAccepted, setIsAgreementAccepted] = useState<boolean>(false);
    const texts = getTexts();

    // Sayfa yüklenince localStorage kontrolü
    useEffect(() => {
        const agreementAccepted = localStorage.getItem("AgreementApprovalChat") === "true";
        setIsAgreementAccepted(agreementAccepted);
    }, []);

    // Onay butonuna basılınca localStorage'a 'true' değeri ekler
    const handleAgreement = () => {
        localStorage.setItem("AgreementApprovalChat", "true");
        setIsAgreementAccepted(true);

        // Storage event'ini manuel tetikle
        window.dispatchEvent(new Event('storage'));
    };

    const handleOpenLink = (url: string) => {
        if (typeof window !== 'undefined') {
            (window as any).handleLinkClick(url);
        }
    };

    // Eğer onay verilmişse popup'ı gösterme
    if (isAgreementAccepted) return null;

    return (
        <div className="fullscreen-popup">
            <div className="popup-content">
                <div className="icon-container">
                    <img src="/images/sozlesme-icon.svg" alt={texts.agreementTitle} />
                </div>
                <div className="popup-texts">
                    <h3 className="popup-title">{texts.agreementTitle}</h3>
                    <p className="popup-desc">{texts.agreementDescription}</p>
                    <div className="col-12 text-center mb-2">
                        <button
                            className="link-button"
                            onClick={() => handleOpenLink('https://www.happ.health/pages/hizmetsozlesmesi')}
                        >
                            {texts.serviceAgreement}
                        </button>
                    </div>
                    <div className="col-12 text-center mb-2">
                        <button
                            className="link-button"
                            onClick={() => handleOpenLink('https://www.happ.health/pages/kvkk')}
                        >
                            {texts.consentText}
                        </button>
                    </div>
                </div>

                <div className="button-container">
                    <button className="btn btn-approve" onClick={handleAgreement}>
                        {texts.approve}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserAgreementPopup;
